import { render, staticRenderFns } from "./AddObstetric.vue?vue&type=template&id=8f6a1a8a&scoped=true"
import script from "./AddObstetric.vue?vue&type=script&lang=js"
export * from "./AddObstetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a1a8a",
  null
  
)

export default component.exports